import { render } from "./ModelMaster.vue?vue&type=template&id=6c5577f9&scoped=true"
import script from "./ModelMaster.vue?vue&type=script&lang=js"
export * from "./ModelMaster.vue?vue&type=script&lang=js"

import "./ModelMaster.vue?vue&type=style&index=0&id=6c5577f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5577f9"]])

export default __exports__